/* eslint-disable import/max-dependencies */
import { useAdobeDtm } from './useAdobeDtm';
import { useDatadog } from './useDatadog';
import { useFullStory } from 'mf_core/config';
import { useHtmlLang } from './useHtmlLang';
import { useUjetChatBot } from './useUjetChatBot';
import { useUjetUniteChatBot } from './useUjetUniteChatBot';
import { useChatBotHelpMenu } from './useChatBotHelpMenu';
import { useWalkMe } from './useWalkMe';
import { useWhatfix } from './useWhatfix';
import { useCookieDisclaimer } from './useCookieDisclaimer';
import { useAddMetaTag } from './useAddMetaTag';
import { useForstaFeedback } from './useForstaFeedback';
import { useFeedbackFormRouter } from './useFeedbackFormRouter';
import { useFirebaseLoader } from './useFirebase';

type UseScriptInjectorsProps = {
  isFirstLogin: boolean;
  resellerProspect: boolean;
};

export function useScriptInjectors({
  isFirstLogin,
  resellerProspect,
}: UseScriptInjectorsProps) {
  useAddMetaTag();
  useAdobeDtm();
  useChatBotHelpMenu();
  useCookieDisclaimer({ resellerProspect });
  useDatadog();
  useFeedbackFormRouter();
  useForstaFeedback();
  useFullStory();
  useHtmlLang();
  useUjetChatBot();
  useUjetUniteChatBot();
  useWalkMe(isFirstLogin);
  useWhatfix(isFirstLogin);
  useFirebaseLoader();
}
